/** A refused save as the form popup shows it: a French message, and the server's reason on its own line. */
export interface FormError {
  message: string;
  /** The API's reason, worded in English as the API words it, or null when it gave none. */
  detail: string | null;
}

export function saveFailure(e: unknown): FormError {
  const reason = (e as { response?: { data?: { error?: unknown } } } | undefined)?.response?.data?.error;
  return {
    message: 'Impossible de sauvegarder la configuration.',
    detail: typeof reason === 'string' && reason !== '' ? reason : null,
  };
}
